import { Table } from "react-table-8.10.7";
import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { SelectedFloatingControl } from "components/SelectedFloatingControl/SelectedFloatingControl";
import { useModal } from "hooks/useModal";
import { pluralize } from "utils/pluralize";
import { TaxFiling } from "store/apis/filing";
import { MarkFilingsFiledModal } from "./MarkFilingsFiledModal";

type FilingSelectionControlsProps = {
  table: Table<TaxFiling>;
  entityId: string;
};

export const FilingSelectionControls = ({
  table,
  entityId,
}: FilingSelectionControlsProps) => {
  const markFilingsFiledModal = useModal();

  const selectedFilings = table
    .getSelectedRowModel()
    .flatRows.map((row) => row.original);

  const handleFiled = () => {
    markFilingsFiledModal.close();
    table.resetRowSelection();
  };

  return (
    <>
      <SelectedFloatingControl>
        {selectedFilings.length > 0 && (
          <>
            <span className="t-whitespace-nowrap t-text-subtext t-text-text-60">
              {pluralize(selectedFilings.length, "filing", "filings")} selected
            </span>
            <Button
              size="small"
              customType="secondary"
              onClick={markFilingsFiledModal.open}
            >
              Mark as filed
            </Button>
            <Button
              customType="ghost_icon"
              size="xsmall"
              onClick={() => table.resetRowSelection()}
            >
              <Cross />
            </Button>
          </>
        )}
      </SelectedFloatingControl>
      <MarkFilingsFiledModal
        open={markFilingsFiledModal.isOpen}
        onClose={markFilingsFiledModal.close}
        filings={selectedFilings}
        entityId={entityId}
        onFiled={handleFiled}
      />
    </>
  );
};
